import {Routes} from "@angular/router";
import {WorkflowEndcustomerOneDowngradeSlaComponent} from "./workflow-endcustomer-one-downgrade-sla.component";

export const workflowEndcustomerOneDowngradeSlaRouting: Routes = [
    { path: 'downgrade-sla/:aid', component: WorkflowEndcustomerOneDowngradeSlaComponent, children: [
        { path: 'info', component: WorkflowEndcustomerOneDowngradeSlaComponent },
        { path: 'address', component: WorkflowEndcustomerOneDowngradeSlaComponent },
        { path: 'payment', component: WorkflowEndcustomerOneDowngradeSlaComponent },
        { path: 'checkout', component: WorkflowEndcustomerOneDowngradeSlaComponent },
        { path: 'complete', component: WorkflowEndcustomerOneDowngradeSlaComponent },
        { path: '', redirectTo: 'info', pathMatch: 'full' },
    ]},
]
